import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { translations } from '../locales/translations';
import './Privacy.css';

function Privacy() {
  const { language } = useContext(LanguageContext);
  const t = translations[language].privacy;

  return (
    <div className="privacy-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">{t.title}</h1>
          <p className="last-updated">{t.last_updated}</p>
        </div>
      </div>

      <div className="section">
        <div className="container">
          <div className="privacy-content">
            <p className="privacy-intro">{t.intro}</p>

            <div className="privacy-section">
              <h2 className="privacy-section-title">{t.collection_title}</h2>
              <p className="privacy-text">{t.collection_content}</p>
              <ul className="privacy-list">
                <li>{t.collection_item1}</li>
                <li>{t.collection_item2}</li>
                <li>{t.collection_item3}</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">{t.usage_title}</h2>
              <p className="privacy-text">{t.usage_content}</p>
              <ul className="privacy-list">
                <li>{t.usage_item1}</li>
                <li>{t.usage_item2}</li>
                <li>{t.usage_item3}</li>
                <li>{t.usage_item4}</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">{t.storage_title}</h2>
              <p className="privacy-text">{t.storage_content}</p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">{t.sharing_title}</h2>
              <p className="privacy-text">{t.sharing_content}</p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">{t.security_title}</h2>
              <p className="privacy-text">{t.security_content}</p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">{t.children_title}</h2>
              <p className="privacy-text">{t.children_content}</p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">{t.changes_title}</h2>
              <p className="privacy-text">{t.changes_content}</p>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">{t.contact_title}</h2>
              <p className="privacy-text">{t.contact_content}</p>
              <div className="contact-box">
                <a href="mailto:wsmslgh@gmail.com" className="contact-link">
                  wsmslgh@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
